import AdminApplications from "../../components/Admin/AdminApplications";
import DashboardLayout from "../../components/Layout/DashboardLayout";
import { applicationStageMap } from "../../config/applicationStatusConfig";

const DLTCApplications = () => {
  return (
    <DashboardLayout pageTitle="Application" mainClass="p-6">
      <AdminApplications
        title="DLCT Applications"
        status={[]}
        stage={[applicationStageMap?.dlct.value]}
      />
    </DashboardLayout>
  );
};

export default DLTCApplications;
